// extracted by mini-css-extract-plugin
module.exports = {"pt-trust-order":"pt-trust-order-4c249a852270351677104202d80654be"};